const EVENT = {
  CONNECT: 'connected',
  COUNT: 'notificationCountUpdate',
  EMPLOYEE_PERMISSIONS_UPDATE: 'employeePermissionsUpdate',
  SUBSCRIPTIONS_UPDATE: 'subscriptionsUpdate',
  CONNECTED: 'connect',
};

export default EVENT;
